import React from "react";

const Loading = () => {
    return (
        <div className="min-h-[50vh] flex justify-center items-center">
            <button className="btn bg-transparent border-0 text-primary capitalize text-xl loading">Loading....... Please wait.</button>
        </div>
    );
};

export default Loading;
